import React from 'react';
import {
  ChakraProvider,
  Box,
  Text,
  Link,
  VStack,
  Code,
  Grid,
  theme,
} from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ColorModeSwitcher } from './ColorModeSwitcher';
import { Logo } from './Logo';
import GhlLogin from './pages/GhlLogin';
import Authorize from './pages/Authorize';
import NotFound from './pages/NotFound';
import Success from './pages/Success';

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<GhlLogin />} />
          <Route path="/authorize" element={<Authorize />} />
          <Route path="/success" element={<Success />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </Router>
  );
}

export default App;
